<template lang="html">
    <!-- on FAQ -->
    <div v-if="faqpage" class="w-100">
        <!-- ROVINIETA -->
        <template v-if="checkIfCategoryHasQuestionsInLanguage('rovinieta')">
            <p class="heading-medium" id="qv">{{ capitalize($tc('vignetteWord', 1)) }}</p>
            <div class="wrapper" v-for="item in filteredItems" v-if="item.rovinieta && getQuestionString(item, 'title', 'rovinieta')">
                <div class="question-wrapper" :id="'question-wrapper-' + item.rovinieta.id">
                    <p @click="displayContent(item.rovinieta.id)"><strong class="question-title">{{ getQuestionString(item, 'title', 'rovinieta') }}</strong></p>
                    <div :id="item.rovinieta.id" class="question-content">
                        <div class="answer" v-html="getQuestionString(item, 'answer', 'rovinieta')"></div>
                    </div>
                </div>
            </div>
        </template>
        <!-- TPF -->
        <template v-if="checkIfCategoryHasQuestionsInLanguage('tpf')">
            <p class="heading-medium" id="qt">{{ $tc('tollWord', 0) }}</p>
            <div class="wrapper" v-for="item in filteredItems" v-if="item.tpf && getQuestionString(item, 'title', 'tpf')">
                <div class="question-wrapper" :id="'question-wrapper-' + item.tpf.id">
                    <p @click="displayContent(item.tpf.id)"><strong class="question-title">{{ getQuestionString(item, 'title', 'tpf') }}</strong></p>
                    <div :id="item.tpf.id" class="question-content">
                        <div class="answer" v-html="getQuestionString(item, 'answer', 'tpf')"></div>
                    </div>
                </div>
            </div>
        </template>
    </div>
    <div class="w-100" v-else>
        <!-- on tpf or vignette or homepage page -->
        <div class="question-wrapper" v-if="getQuestionString(item, 'title')" v-for="item in filteredItems" :id="'question-wrapper-' + item.id">
            <div class="inner">
                <p@click="displayContent(item.id)"><strong class="question-title">{{ getQuestionString(item, 'title') }}</strong></p>
                <div :id="item.id" class="question-content">
                    <div class="answer" v-html="getQuestionString(item, 'answer')"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import questionsJSON from './../assets/questions/questions.json'
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'FrequentQuestionComponent',
        data() {
            return {
                questions: questionsJSON
            }
        },
        props: {
            count: 0,
            category: '',               // not required on homepage
            homepage: false,            // required on homepage
            faqpage: false,             // is about FAQ page
        },
        computed:{
             ...mapGetters({
                getNoQuestions: 'faq/getNoQuestions',
                language: 'language/getLanguage',
                fallBackLanguage: 'language/getFallBackLanguage'
            }),
            filteredItems: function () {
                var arr = []
                // if is homepage
                if(this.homepage) {
                    this.questions.forEach(element => {
                        if(element.visibleInHomepage == this.homepage) {
                            arr.push(element)
                        }
                    });
                    return arr.slice(0, this.count)
                //if is faq page
                } else if(this.faqpage) {
                    this.questions.forEach(element => {
                        if(element.category == 'rovinieta') {
                            arr.push({rovinieta:element})
                        }
                        if(element.category == 'tpf') {
                            arr.push({tpf:element})
                        }
                    });
                    return arr
                } else {
                //if is tpf or vignette page
                    this.questions.forEach(element => {
                        if(element.category == this.category) {
                            arr.push(element)
                        }
                    });
                    //set total number of questions in order to check if the "more" btn can be displayed
                    this.mutateSetNoQuestions(arr.length);

                    return arr.slice(0, this.count)
                }
            },


        },
        methods: {
            ...mapActions({
                mutateSetNoQuestions:'faq/mutateSetNoQuestions',
            }),
            displayContent(contentId) {
                $(`#${contentId}`).toggle();
                //toggle class in order to know when the accordion is opened
                $('#question-wrapper-' + contentId).toggleClass('opened');
            },

            getQuestionString(question, stringType, type = false) {
                if(!type) {
                    return question[stringType][this.language] ? question[stringType][this.language] : (question[stringType][this.fallBackLanguage] ? question[stringType][this.fallBackLanguage] : false);
                }

                return question[type][stringType][this.language] ?
                        question[type][stringType][this.language] :
                        (
                            question[type][stringType][this.fallBackLanguage] ?
                            question[type][stringType][this.fallBackLanguage] :
                            false
                        );
            },

            checkIfCategoryHasQuestionsInLanguage(type) {
                let count = 0;
                for (let key in this.filteredItems) {
                    if(typeof this.filteredItems[key][type] != 'undefined' && this.getQuestionString(this.filteredItems[key], 'title', type) != false) {
                        count++;
                    }
                }

                return count;
            }
        },
    }
</script>

<style lang="scss" scoped>

    h2 {
        font-size: 34px;
        font-weight: bold;
        margin-bottom: 20px;
    }

    a {
        padding: 0 16px;
        text-decoration: underline;
        &:hover{
            color: #737880;
        }
    }
    .question-wrapper {
        color: #0F2443;
        width: 100%;
        background-color: #EEEDEC;
        border-radius: 4px;
        padding: 30px 16px;
        position: relative;
        margin-bottom: 20px;
        &.opened {
            &::after {
            content: url('../media/icons/arrow_opened.svg');
            }
        }
        .inner {
            padding-right: 20px;
        }
        p {
            margin:0;
            &:hover{
                cursor: pointer;
            }
        }
        &::after{
            content: url('../media/icons/arrow.svg');
            position: absolute;
            color: black;
            right: 20px;
            top: 32px;
            width: 15px;
            height: 10px;
        }
        .question-content{
            display: none;
            padding:10px 0 0 0;
        }
        .answer {
            font-size: 16px;
        }

        .question-title {
            padding-right: 30px;
            display: block;
        }
    }
</style>
